export default {
  add_items: 'Artikelen toevoegen',
  remove_items: 'Artikelen verwijderen',
  place_order: 'Bestelling plaatsen',
  pay_now: 'Nu betalen · {{amount}}',
  go_to_menu: 'Naar het menu',
  secure_checkout: 'Veilig afrekenen...',

  error_messages: {
    payment_unsuccessful: {
      title: 'Betaling mislukt',
      description: 'Controleer je betaalgegevens en probeer het opnieuw.',
    },
    internal_error: {
      title: 'Bestelling mislukt 😔',
      description: 'Helaas was er een onverwacht probleem met je bestelling. Ons technisch team is er al mee bezig 🛠️.',
    },
    order_blocked: {
      title: 'Bestelling geblokkeerd',
      description:
        'We hebben verdachte activiteit op je account gedetecteerd en nieuwe bestellingen geblokkeerd tot {{datetime}}. Neem contact op met support via {{supportEmail}} voor meer informatie.',
      description_no_datetime:
        'We hebben verdachte activiteit op je account gedetecteerd en nieuwe bestellingen geblokkeerd. Neem contact op met support via {{supportEmail}} voor meer informatie.',
    },
  },

  toasts: {
    input_errors_found: 'Er zijn problemen met je bestelgegevens',
    select_payment_method: 'Kies een betaalmethode om je bestelling te plaatsen.',
  },
};
